export enum MapViewEvents {
  changeStart = 'mapviewchangestart',
  change = 'mapviewchange',
  changeEnd = 'mapviewchangeend',
}

export enum MapEvents {
  pointerDown = 'pointerdown',
  pointerUp = 'pointerup',
}
